<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg px-5 overflow-auto"
      >
        <div class="flex flex-col sticky top-0 bg-white pt-5 z-50">
          <div class="flex">
            <div
              class="w-4/5 text-left px-3 pb-3 text-purple-700 text-2xl font-bold"
            >
              Ficha de registro
            </div>
            <div class="w-1/5 text-right">
              <button
                aria-label="close"
                class="text-xl text-gray-500"
                @click.prevent="close"
              >
                ×
              </button>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="flex flex-col w-full">
            <form
              class="w-full max-w-lg"
              id="levantamientoForm"
              @submit.prevent
              @focusin="handleFocusIn"
            >
              <div v-show="showCategoriesView">
                <div class="flex flex-wrap -mx-3 pb-3">
                  <!-- <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="name"
                      >Título</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="name"
                      type="text"
                      name="name"
                      v-model="nameLevantamiento"
                    />
                    <p
                      v-if="errors.name"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Ingrese un título.
                    </p>
                  </div> -->

                  <!-- <div class="w-full px-3 mb-6 md:mb-0 hidden">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="fromProject"
                      >¿Desea colaborar con un proyecto?</label
                    >
                    <div class="relative">
                      <select
                        v-model="fromProject"
                        name="fromProject"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option disabled selected>Seleccione una</option>
                        <option>Si</option>
                        <option>No</option>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div> -->

                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="selectProject"
                      >Proyecto</label
                    >
                    <div class="relative">
                      <select
                        v-model="projectSelected"
                        id="selectProject"
                        name="selectProject"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option disabled selected>Seleccione una</option>
                        <template v-for="project in projects">
                          <option
                            :key="'projLev' + project.id"
                            :value="project.id"
                          >
                            {{ project.nombre }}
                          </option>
                        </template>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.selectProject"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Seleccione un proyecto.
                    </p>
                    <div v-if="projectSelected !== null" class="flex text-left">
                      <button
                        @click="showProjectDetailModal()"
                        class="bg-transparent hover:bg-purple-500 text-purple-700 font-semibold hover:text-white py-1 px-4 mx-1 mt-0 border border-purple-500 hover:border-transparent rounded"
                      >
                        Ver proyecto
                      </button>
                    </div>
                  </div>

                  <!-- <div
                    class="w-full px-3 mb-6 md:mb-0"
                    v-if="fromProject === 'No'"
                  >
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="isMaterial"
                      >¿Qué es lo que desea registrar?</label
                    >
                    <div class="relative" style="display: flex; height: 150px">
                      <div style="width: 50%; margin: 10px">
                        <div
                          id="optionMaterial"
                          @click="selectOptionLevantamiento('1')"
                          style="background-color: #ff9802"
                          class="optionTypeLevantamiento"
                        >
                          <span style="color: #000000">
                            Lo que quiero registrar es un objeto, un lugar, un
                            edificio
                          </span>
                        </div>
                      </div>
                      <div style="width: 50%; margin: 10px">
                        <div
                          id="optionInmaterial"
                          @click="selectOptionLevantamiento('2')"
                          style="background-color: #3880e6"
                          class="optionTypeLevantamiento"
                        >
                          <span style="color: #000000">
                            Lo que quiero registrar es algo que se transmite por
                            medio del habla, la observación o la práctica
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="relative" style="display: none">
                      <select
                        v-model="isMaterial"
                        name="isMaterial"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option disabled selected>Seleccione una</option>
                        <option value="1">Si</option>
                        <option value="2">No</option>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.isMaterial"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Seleccione una opción.
                    </p>
                  </div> -->

                  <!-- <div class="w-full px-3 mb-6 md:mb-0">
                    <label class="w-full flex items-center text-gray-900">
                      <input
                        class="mr-2 leading-tight"
                        type="checkbox"
                        v-model="sensitiveLocation"
                      />
                      <span class="text-sm">Mantener ubicación oculta</span>
                    </label>
                  </div>

                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label class="w-full flex items-center text-gray-900">
                      <input
                        class="mr-2 leading-tight"
                        type="checkbox"
                        v-model="hiddenQuestions"
                      />
                      <span class="text-sm">Ocultar la ficha</span>
                    </label>
                  </div> -->
                </div>
              </div>

              <div v-show="showMultimediaView">
                <div class="flex flex-wrap -mx-3 pb-3 px-5 justify-center">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left flex items-center"
                    >
                      Subir archivo
                      <span
                        class="pl-2 cursor-pointer"
                        @click="showingMediaProject = true"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6 fill-current"
                        >
                          <path
                            d="M11.95 18Q12.475 18 12.838 17.637Q13.2 17.275 13.2 16.75Q13.2 16.225 12.838 15.863Q12.475 15.5 11.95 15.5Q11.425 15.5 11.062 15.863Q10.7 16.225 10.7 16.75Q10.7 17.275 11.062 17.637Q11.425 18 11.95 18ZM11.05 14.15H12.9Q12.9 13.325 13.088 12.85Q13.275 12.375 14.15 11.55Q14.8 10.9 15.175 10.312Q15.55 9.725 15.55 8.9Q15.55 7.5 14.525 6.75Q13.5 6 12.1 6Q10.675 6 9.788 6.75Q8.9 7.5 8.55 8.55L10.2 9.2Q10.325 8.75 10.763 8.225Q11.2 7.7 12.1 7.7Q12.9 7.7 13.3 8.137Q13.7 8.575 13.7 9.1Q13.7 9.6 13.4 10.037Q13.1 10.475 12.65 10.85Q11.55 11.825 11.3 12.325Q11.05 12.825 11.05 14.15ZM12 22Q9.95 22 8.125 21.212Q6.3 20.425 4.938 19.075Q3.575 17.725 2.788 15.9Q2 14.075 2 12Q2 9.925 2.788 8.1Q3.575 6.275 4.938 4.925Q6.3 3.575 8.125 2.787Q9.95 2 12 2Q14.1 2 15.925 2.787Q17.75 3.575 19.1 4.925Q20.45 6.275 21.225 8.1Q22 9.925 22 12Q22 14.075 21.225 15.9Q20.45 17.725 19.1 19.075Q17.75 20.425 15.925 21.212Q14.1 22 12 22ZM12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12ZM12 20Q15.35 20 17.675 17.663Q20 15.325 20 12Q20 8.675 17.675 6.337Q15.35 4 12 4Q8.725 4 6.362 6.337Q4 8.675 4 12Q4 15.325 6.362 17.663Q8.725 20 12 20Z"
                          />
                        </svg>
                      </span>
                    </label>
                    <p
                      class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                    >
                      Seleccione hasta 4 fotos o un video.
                    </p>
                    <div
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 mb-3 leading-tight focus:outline-none focus:bg-white"
                    >
                      <label
                        for="levantamientoFile"
                        class="flex w-full cursor-pointer -my-2 whitespace-no-wrap"
                      >
                        <span
                          class="bg-gray-900 text-gray-100 py-2 px-4 p rounded-l"
                          >Seleccionar archivo</span
                        >
                        <span class="py-2 px-4 truncate">{{
                          inputFilePlaceholder
                        }}</span>
                        <input
                          @change="changeLevantamientoFile"
                          class="sr-only"
                          type="file"
                          name="levantamientoFile"
                          id="levantamientoFile"
                          accept="image/png, image/jpeg, video/mp4"
                          multiple
                        />
                      </label>
                    </div>
                    <p
                      v-if="errors.emptyFile"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Seleccione un archivo.
                    </p>
                  </div>

                  <div v-show="imageSelected" class="flex flex-wrap">
                    <div
                      v-for="(preview, mediaIndex) in imagesPreviews"
                      :key="mediaIndex"
                      class="flex w-1/2 h-72 flex-grow px-2 pb-4"
                      v-show="preview.type !== ''"
                    >
                      <img
                        v-if="preview.type === 'image'"
                        :src="preview.mediaUrl"
                        class="h-full w-full object-cover"
                        alt=""
                      />
                      <video
                        v-if="preview.type === 'video'"
                        :src="preview.mediaUrl"
                        class="h-full w-full bg-gray-300"
                        controls
                      ></video>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Formulario de ficha -->
              <div v-show="showFormView">
                <div class="flex flex-wrap -mx-3 pb-3">
                  <div
                    class="w-full"
                    v-for="(question, index) in questions"
                    :key="'question' + index"
                    :data-q-index="index"
                    :class="nestedStatusFicha[index] ? 'pl-6 border-l-4 border-gray-300 ml-2 mb-4' : 'mb-4'"
                    v-show="isQuestionVisible(index)"
                  >
                    <div v-if="question.tipo === 'SECCION'" class="w-full mb-2 bg-gray-200 border-l-4 border-gray-500 p-2 rounded shadow-sm">
                      <label class="block uppercase tracking-wider text-gray-800 text-sm font-bold text-left">
                        {{ question.numero_pregunta }}.- {{ question.texto }}
                        <template v-if="question.nota_para_registrante != ''">
                          ({{ question.nota_para_registrante }})
                        </template>
                      </label>
                    </div>
                    <!-- pregunta tipo ABIERTA -->
                    <div v-if="question.tipo === 'ABIERTA'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <template v-if="question.tipo_dato === 'numero'">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            :id="'question' + index"
                            type="number"
                            :min="question.rango_min"
                            :max="question.rango_max"
                            :name="'question' + index"
                            v-model.number="answers[index].respuesta"
                          />
                        </template>
                        <template v-else-if="question.tipo_dato === 'fecha'">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            :id="'question' + index"
                            type="date"
                            :name="'question' + index"
                            v-model="answers[index].respuesta"
                          />
                        </template>
                        <template v-else-if="question.tipo_dato === 'hora'">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            :id="'question' + index"
                            type="time"
                            :name="'question' + index"
                            v-model="answers[index].respuesta"
                          />
                        </template>
                        <template v-else>
                          <textarea
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            :id="'question' + index"
                            type="text"
                            :name="'question' + index"
                            v-model="answers[index].respuesta"
                          />
                        </template>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
                        <p
                          v-if="answers[index].error_rango"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          El valor debe estar entre {{ question.rango_min !== null ? question.rango_min : '-∞' }} y {{ question.rango_max !== null ? question.rango_max : '∞' }}.
                        </p>
                      </div>
                      <!--                       <div class="w-full px-3 mb-3">
                        <label class="w-full flex items-center text-gray-900">
                          <input
                            class="mr-2 leading-tight"
                            type="checkbox"
                            v-model="answers[index].sensible"
                          />
                          <span class="text-sm">
                            Contiene información sensible
                          </span>
                        </label>
                      </div> -->
                    </div>
                    <!-- /pregunta tipo ABIERTA -->

                    <!-- pregunta tipo FOTO -->
                    <div v-if="question.tipo === 'FOTO'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}
                          <span class="text-gray-500 font-normal text-xs ml-1">(Máximo {{ question.max_fotos || 4 }} fotos)</span>
                        </label>
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-2 leading-tight focus:outline-none focus:bg-white"
                          type="file"
                          accept="image/*"
                          multiple
                          :disabled="answers[index].respuesta && Array.isArray(answers[index].respuesta) && answers[index].respuesta.length >= (question.max_fotos || 4)"
                          @change="onPhotoChange($event, index)"
                        />
                        <!-- Preview grid -->
                        <div v-if="answers[index].respuesta && Array.isArray(answers[index].respuesta) && answers[index].respuesta.length > 0" class="flex flex-wrap gap-3 mt-2">
                          <div v-for="(photo, pIdx) in answers[index].respuesta" :key="'p_' + pIdx" class="relative">
                            <img :src="photo" class="w-24 h-24 object-cover rounded border border-gray-300 shadow-sm" />
                            <button
                              type="button"
                              class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs shadow hover:bg-red-600 focus:outline-none"
                              @click="removePhoto(index, pIdx)"
                              title="Eliminar foto"
                            >×</button>
                          </div>
                        </div>
                        <div v-else-if="answers[index].respuesta && typeof answers[index].respuesta === 'string'" class="relative inline-block mt-2">
                          <img :src="answers[index].respuesta" class="w-28 h-28 object-cover rounded border border-gray-300 shadow-sm" />
                          <button
                            type="button"
                            class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs shadow hover:bg-red-600 focus:outline-none"
                            @click="removePhoto(index, 0)"
                            title="Eliminar foto"
                          >×</button>
                        </div>
                        <p v-if="answers[index].error" class="text-red-500 text-xs italic mt-1">
                          Debe adjuntar al menos una fotografía.
                        </p>
                      </div>
                    </div>
                    <!-- /pregunta tipo FOTO -->

                    <!-- pregunta tipo MULTISELECCION -->
                    <div v-if="question.tipo === 'MULTISELECCION'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <template
                          v-for="(option, optIndex) in question.opciones"
                        >
                          <div
                            class="flex items-center text-gray-700 font-bold"
                            :class="
                              optIndex === question.opciones.length - 1 &&
                              !question.otro
                                ? 'mb-3'
                                : ''
                            "
                            :key="'opt' + optIndex"
                          >
                            <input
                              class="mr-2 leading-tight"
                              type="checkbox"
                              v-model="
                                answers[index].respuesta.opciones[option]
                              "
                            />
                            <span class="text-sm">
                              {{ option }}
                            </span>
                          </div>
                        </template>
                        <div
                          v-if="question.otro"
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <input class="mr-2 leading-tight" type="checkbox" />
                          <span class="text-sm"> Otro </span>
                          <input
                            v-if="!question.tipo_otro || question.tipo_otro === 'texto'"
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                          <input
                            v-else-if="question.tipo_otro === 'numero'"
                            type="number"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model.number="answers[index].respuesta.otro"
                          />
                          <input
                            v-else-if="question.tipo_otro === 'fecha'"
                            type="date"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                          <input
                            v-else-if="question.tipo_otro === 'hora'"
                            type="time"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                        </div>

                        <!-- Subpreguntas de la pregunta multiselección -->
                        <template
                          v-for="(
                            subpregunta, subSIndex
                          ) in question.subpregunta"
                        >
                          <div
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'subS' + subSIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'subquestion' + subSIndex"
                              >{{ subpregunta.numero_pregunta }}.-
                              {{ subpregunta.texto }}</label
                            >
                            <!-- Subpregunta tipo multiselección->abierta -->
                            <template v-if="subpregunta.tipo === 'ABIERTA'">
                              <textarea
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                :id="'subquestion' + subSIndex"
                                type="text"
                                :name="'subquestion' + subSIndex"
                                v-model="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta
                                "
                              />
                              <p
                                v-if="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].error
                                "
                                class="text-red-500 text-xs italic pb-3"
                              >
                                Ingrese la respuesta.
                              </p>
                              <!--                               <div class="w-full px-3 mb-3">
                                <label
                                  class="w-full flex items-center text-gray-900"
                                >
                                  <input
                                    class="mr-2 leading-tight"
                                    type="checkbox"
                                    v-model="
                                      answers[index].respuesta.subpregunta[
                                        subSIndex
                                      ].sensible
                                    "
                                  />
                                  <span class="text-sm">
                                    Contiene información sensible
                                  </span>
                                </label>
                              </div> -->
                            </template>
                            <!-- /Subpregunta tipo multiselección->abierta -->

                            <!-- /Subpregunta tipo multiselección->selección -->
                            <template v-if="subpregunta.tipo === 'SELECCION'">
                              <div class="relative">
                                <select
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].respuesta.selected_answer
                                  "
                                  :name="'subquestion' + subSIndex"
                                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                >
                                  <option disabled selected>
                                    Seleccione una
                                  </option>
                                  <template
                                    v-for="(
                                      option, subOIndex
                                    ) in subpregunta.opciones"
                                  >
                                    <option
                                      :key="'subO' + subOIndex"
                                      :value="option"
                                    >
                                      {{ option }}
                                    </option>
                                  </template>
                                  <option
                                    v-if="subpregunta.otro == true"
                                    value="Otro"
                                  >
                                    Otro
                                  </option>
                                </select>

                                <div
                                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                                >
                                  <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div
                                v-if="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta.selected_answer === 'Otro'
                                "
                                class="flex items-center text-gray-700 font-bold mb-3"
                              >
                                <span class="text-sm"> Otro </span>
                                <input
                                  type="text"
                                  class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].respuesta.otro
                                  "
                                />
                              </div>

                              <p
                                v-if="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].error
                                "
                                class="text-red-500 text-xs italic pb-3"
                              >
                                Seleccione la respuesta.
                              </p>
                            </template>
                            <!-- /Subpregunta tipo multiselección->selección -->

                            <!-- Subpregunta tipo multiselección->campos -->
                            <template v-if="subpregunta.tipo === 'CAMPOS'">
                              <template
                                v-for="(
                                  campo, subFieldIndex
                                ) in subpregunta.campos"
                              >
                                <template v-if="campo.tipo === 'texto'">
                                  <div :key="'subf' + subFieldIndex">
                                    <label
                                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                      :for="'subquestionField' + subFieldIndex"
                                      >{{ campo.texto }}</label
                                    >
                                    <input
                                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                      :id="'subquestionField' + subFieldIndex"
                                      type="text"
                                      :name="'subquestionField' + subFieldIndex"
                                      v-model="
                                        answers[index].respuesta.subpregunta[
                                          subSIndex
                                        ].respuesta[campo.texto]
                                      "
                                    />
                                  </div>
                                </template>
                              </template>
                              <p
                                v-if="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].error
                                "
                                class="text-red-500 text-xs italic pb-3"
                              >
                                Ingrese la respuesta.
                              </p>
                              <!--                               <div class="w-full px-3 mb-3">
                                <label
                                  class="w-full flex items-center text-gray-900"
                                >
                                  <input
                                    class="mr-2 leading-tight"
                                    type="checkbox"
                                    v-model="
                                      answers[index].respuesta.subpregunta[
                                        subSIndex
                                      ].sensible
                                    "
                                  />
                                  <span class="text-sm">
                                    Contiene información sensible
                                  </span>
                                </label>
                              </div> -->
                            </template>
                            <!-- /Subpregunta tipo multiselección->campos -->
                          </div>
                        </template>
                        <!-- /Subpreguntas de la pregunta multiselección -->
                      </div>
                    </div>
                    <!-- /pregunta tipo MULTISELECCION -->

                    <!-- pregunta tipo SELECCION_CONDICIONAL -->
                    <div v-if="question.tipo === 'SELECCION_CONDICIONAL'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.selected_answer"
                            :name="'question' + index"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected>Seleccione una</option>
                            <template
                              v-for="(option, scOIndex) in question.opciones"
                            >
                              <option :key="'scO' + scOIndex" :value="option">
                                {{ option }}
                              </option>
                            </template>
                          </select>
                          <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                          >
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </div>
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione la respuesta.
                        </p>
                      </div>

                      <!-- preguntas condicionadas -->
                      <template
                        v-for="(
                          value, key, keyIndex
                        ) in question.pregunta_condicion"
                      >
                        <template
                          v-if="
                            answers[index].respuesta.selected_answer === key
                          "
                        >
                          <!-- pregunta condicionada tipo abierta -->
                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo ===
                              'ABIERTA'
                            "
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'condQ' + keyIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <textarea
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'questionCond' + index"
                              type="text"
                              :name="'questionCond' + index"
                              v-model="
                                answers[index].respuesta.conditional_answer[key]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.conditional_answer[key]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
                            <!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </div>
                          <!-- /pregunta condicionada tipo abierta -->

                          <!-- pregunta condicionada multiselección -->
                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo ===
                              'MULTISELECCION'
                            "
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'condQ' + keyIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <p
                              v-if="
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              "
                              class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                            >
                              {{
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              }}
                            </p>
                            <template
                              v-for="(option, scMOIndex) in question
                                .pregunta_condicion[key].opciones"
                            >
                              <div
                                class="flex items-center text-gray-700 font-bold"
                                :class="
                                  scMOIndex ===
                                    question.pregunta_condicion[key].opciones
                                      .length -
                                      1 &&
                                  !question.pregunta_condicion[key].otro
                                    ? 'mb-3'
                                    : ''
                                "
                                :key="'scM' + scMOIndex"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].respuesta.opciones[option]
                                  "
                                />
                                <span class="text-sm">
                                  {{ option }}
                                </span>
                              </div>
                            </template>
                            <div
                              v-if="question.pregunta_condicion[key].otro"
                              class="flex items-center text-gray-700 font-bold mb-3"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="checkbox"
                              />
                              <span class="text-sm"> Otro </span>
                              <input
                                type="text"
                                class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="
                                  answers[index].respuesta.conditional_answer[
                                    key
                                  ].respuesta.otro
                                "
                              />
                            </div>
                          </div>
                          <!-- /pregunta condicionada multiselección -->

                          <!-- pregunta condicionada tipo selección -->
                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo ===
                              'SELECCION'
                            "
                            :key="'condQ' + keyIndex"
                            class="w-full px-3 mb-6 md:mb-0"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <p
                              v-if="
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              "
                              class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                            >
                              {{
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              }}
                            </p>
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.conditional_answer[
                                    key
                                  ].respuesta
                                "
                                :name="'questionCond' + index"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(option, condOIndex) in question
                                    .pregunta_condicion[key].opciones"
                                >
                                  <option
                                    :key="'condO' + condOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                              </select>
                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <!-- /pregunta condicionada tipo selección -->

                          <!-- pregunta condicionada tipo campos -->
                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo === 'CAMPOS'
                            "
                            :key="'condQ' + keyIndex"
                            class="w-full px-3 mb-6 md:mb-0"
                          >
                            <template
                              v-for="(campo, condFieldIndex) in question
                                .pregunta_condicion[key].campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'condf' + condFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'condField' + condFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'condField' + condFieldIndex"
                                    type="text"
                                    :name="'condField' + condFieldIndex"
                                    v-model="
                                      answers[index].respuesta
                                        .conditional_answer[key].respuesta[
                                        campo.texto
                                      ]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
                            <!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </div>
                          <!-- /pregunta condicionada tipo campos -->
                        </template>
                        <template
                          v-if="
                            answers[index].respuesta.selected_answer === key
                          "
                        >
                          <template
                            v-for="(subpregunta, subQIndex) in question
                              .pregunta_condicion[key].subpregunta"
                          >
                            <div
                              v-if="subpregunta.tipo === 'SELECCION'"
                              :key="'subCondQ' + subQIndex"
                              class="w-full px-3 mb-6 md:mb-0"
                            >
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'subCondQ' + subQIndex"
                                >{{ subpregunta.numero_pregunta }}.-
                                {{ subpregunta.texto }}</label
                              >
                              <p
                                v-if="subpregunta.nota_para_registrante"
                                class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                              >
                                {{ subpregunta.nota_para_registrante }}
                              </p>
                              <div class="relative">
                                <select
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].subpregunta[subQIndex].respuesta
                                  "
                                  :name="'subCondQ' + subQIndex"
                                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                >
                                  <option disabled selected>
                                    Seleccione una
                                  </option>
                                  <template
                                    v-for="(
                                      option, subCondOptIndex
                                    ) in subpregunta.opciones"
                                  >
                                    <option
                                      :key="'subCondOpt' + subCondOptIndex"
                                      :value="option"
                                    >
                                      {{ option }}
                                    </option>
                                  </template>
                                </select>
                                <div
                                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                                >
                                  <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                      </template>
                      <!-- /preguntas condicionadas -->
                    </div>
                    <!-- /pregunta tipo SELECCION_CONDICIONAL -->

                    <!-- pregunta tipo SELECCION -->
                    <div v-if="question.tipo === 'SELECCION'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.selected_answer"
                            :name="'question' + index"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected>Seleccione una</option>
                            <template
                              v-for="(option, sOIndex) in question.opciones"
                            >
                              <option :key="'sO' + sOIndex" :value="option">
                                {{ option }}
                              </option>
                            </template>
                            <option v-if="question.otro == true" value="Otro">
                              Otro
                            </option>
                          </select>
                          <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                          >
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          v-if="
                            answers[index].respuesta.selected_answer === 'Otro'
                          "
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <span class="text-sm"> Otro </span>
                          <input
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione la respuesta.
                        </p>
                      </div>

                      <!-- subpreguntas de la pregunta de selección -->
                      <template
                        v-for="(subpregunta, subSIndex) in question.subpregunta"
                      >
                        <div
                          class="w-full px-3 mb-6 md:mb-0"
                          :key="'subS' + subSIndex"
                        >
                          <label
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                            :for="'subquestion' + subSIndex"
                            >{{ subpregunta.numero_pregunta }}.-
                            {{ subpregunta.texto }}</label
                          >
                          <!-- Subpregunta tipo selección->abierta -->
                          <template v-if="subpregunta.tipo === 'ABIERTA'">
                            <textarea
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'subquestion' + subSIndex"
                              type="text"
                              :name="'subquestion' + subSIndex"
                              v-model="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
                            <!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo selección->abierta -->

                          <!-- Subpregunta tipo selección->selección -->
                          <template v-if="subpregunta.tipo === 'SELECCION'">
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta.selected_answer
                                "
                                :name="'subquestion' + subSIndex"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(
                                    option, subOIndex
                                  ) in subpregunta.opciones"
                                >
                                  <option
                                    :key="'subO' + subOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                                <option
                                  v-if="subpregunta.otro == true"
                                  value="Otro"
                                >
                                  Otro
                                </option>
                              </select>

                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>

                            <div
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .respuesta.selected_answer === 'Otro'
                              "
                              class="flex items-center text-gray-700 font-bold mb-3"
                            >
                              <span class="text-sm"> Otro </span>
                              <input
                                type="text"
                                class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta.otro
                                "
                              />
                            </div>

                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Seleccione la respuesta.
                            </p>
                          </template>
                          <!-- /Subpregunta tipo selección->selección -->

                          <!-- Subpregunta tipo selección->campos -->
                          <template v-if="subpregunta.tipo === 'CAMPOS'">
                            <template
                              v-for="(
                                campo, subFieldIndex
                              ) in subpregunta.campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'subf' + subFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'subquestionField' + subFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'subquestionField' + subFieldIndex"
                                    type="text"
                                    :name="'subquestionField' + subFieldIndex"
                                    v-model="
                                      answers[index].respuesta.subpregunta[
                                        subSIndex
                                      ].respuesta[campo.texto]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
                            <!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo selección->campos -->
                        </div>
                      </template>
                      <!-- /subpreguntas de la pregunta de selección -->
                    </div>
                    <!-- /pregunta tipo SELECCION -->

                    <!-- pregunta tipo CAMPOS -->
                    <div v-if="question.tipo === 'CAMPOS'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>

                        <template
                          v-for="(campo, fieldIndex) in question.campos"
                        >
                            <div :key="'f' + fieldIndex" class="mb-3">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'questionField' + fieldIndex"
                                >{{ campo.texto }}</label
                              >
                              <input
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                :id="'questionField' + fieldIndex"
                                :type="campo.tipo === 'numero' ? 'number' : (campo.tipo === 'fecha' ? 'date' : (campo.tipo === 'hora' ? 'time' : 'text'))"
                                :min="campo.tipo === 'numero' ? campo.rango_min : null"
                                :max="campo.tipo === 'numero' ? campo.rango_max : null"
                                :name="'questionField' + fieldIndex"
                                v-model="answers[index].respuesta[campo.texto]"
                              />
                            </div>
                        </template>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
                        <!--                         <div class="w-full px-3 mb-3">
                          <label class="w-full flex items-center text-gray-900">
                            <input
                              class="mr-2 leading-tight"
                              type="checkbox"
                              v-model="answers[index].sensible"
                            />
                            <span class="text-sm">
                              Contiene información sensible
                            </span>
                          </label>
                        </div> -->
                      </div>
                    </div>
                    <!-- /pregunta tipo CAMPOS -->

                    <!-- pregunta tipo MINI_FORMULARIO -->
                    <div v-if="question.tipo === 'MINI_FORMULARIO'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <template>
                            <div v-for="(campo, fieldIndex) in question.campos" :key="'mf' + fieldIndex" class="mb-3">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'mfField' + fieldIndex"
                                >{{ campo.texto }}</label
                              >
                              <template v-if="['texto', 'numero', 'fecha', 'hora'].includes(campo.tipo)">
                                <input
                                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                  :id="'mfField' + fieldIndex"
                                  :type="campo.tipo === 'numero' ? 'number' : (campo.tipo === 'fecha' ? 'date' : (campo.tipo === 'hora' ? 'time' : 'text'))"
                                  :min="campo.tipo === 'numero' ? campo.rango_min : null"
                                  :max="campo.tipo === 'numero' ? campo.rango_max : null"
                                  :name="'mfField' + fieldIndex"
                                  v-model="answers[index].respuesta[campo.texto]"
                                />
                              </template>
                              <template v-else-if="campo.tipo === 'radio'">
                                <div class="flex flex-col gap-2 mb-3 mt-1">
                                  <label v-for="(opt, oi) in campo.opciones" :key="'mfr' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                    <input type="radio"
                                      :name="'mfField' + index + '_' + fieldIndex"
                                      :value="opt"
                                      v-model="answers[index].respuesta[campo.texto]"
                                      class="accent-teal-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </template>
                              <template v-else-if="campo.tipo === 'checkbox'">
                                <div class="flex flex-col gap-2 mb-3 mt-1">
                                  <label v-for="(opt, oi) in campo.opciones" :key="'mfc' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                    <input type="checkbox"
                                      :name="'mfField' + index + '_' + fieldIndex + '_' + oi"
                                      :value="opt"
                                      v-model="answers[index].respuesta[campo.texto]"
                                      class="accent-teal-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </template>
                              <template v-else-if="campo.tipo === 'select'">
                                <div class="relative mt-1 mb-3">
                                  <select
                                    v-model="answers[index].respuesta[campo.texto]"
                                    :name="'mfField' + index + '_' + fieldIndex"
                                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                  >
                                    <option disabled selected value="">Seleccione una</option>
                                    <option v-for="(option, oIndex) in campo.opciones" :key="'mfs' + oIndex" :value="option">
                                      {{ option }}
                                    </option>
                                  </select>
                                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                    </svg>
                                  </div>
                                </div>
                              </template>
                            </div>
                        </template>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese las respuestas obligatorias.
                        </p>
                      </div>
                    </div>
                    <!-- /pregunta tipo MINI_FORMULARIO -->

                    <!-- pregunta tipo GRUPO_REPETIBLE -->
                    <div v-if="question.tipo === 'GRUPO_REPETIBLE'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>

                        <div v-for="(group, gIndex) in answers[index].respuesta" :key="'group_' + gIndex" class="mb-4 p-4 border border-gray-300 rounded relative bg-gray-50">
                          <button v-if="answers[index].respuesta.length > 1" @click="answers[index].respuesta.splice(gIndex, 1)" type="button" class="absolute top-2 right-2 text-red-500 hover:text-red-700">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" /></svg>
                          </button>
                          <div class="font-bold text-gray-600 mb-2 text-sm">Registro {{ gIndex + 1 }}</div>
                          
                          <template v-for="(campo, fieldIndex) in question.campos">
                            <div :key="'rgf_' + gIndex + '_' + fieldIndex" class="mb-3">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1 text-left"
                                >{{ campo.texto }}</label
                              >
                              <template v-if="['texto', 'numero', 'fecha', 'hora'].includes(campo.tipo)">
                                <input
                                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white"
                                  :type="campo.tipo === 'numero' ? 'number' : (campo.tipo === 'fecha' ? 'date' : (campo.tipo === 'hora' ? 'time' : 'text'))"
                                  :min="campo.tipo === 'numero' ? campo.rango_min : null"
                                  :max="campo.tipo === 'numero' ? campo.rango_max : null"
                                  v-model="answers[index].respuesta[gIndex][campo.texto]"
                                />
                              </template>
                              <template v-else-if="campo.tipo === 'radio'">
                                <div class="flex flex-col gap-2 mb-2 mt-1">
                                  <label v-for="(opt, oi) in campo.opciones" :key="'rgr_' + gIndex + '_' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                    <input type="radio"
                                      :name="'rgField_' + index + '_' + gIndex + '_' + fieldIndex"
                                      :value="opt"
                                      v-model="answers[index].respuesta[gIndex][campo.texto]"
                                      class="accent-teal-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </template>
                              <template v-else-if="campo.tipo === 'checkbox'">
                                <div class="flex flex-col gap-2 mb-2 mt-1">
                                  <label v-for="(opt, oi) in campo.opciones" :key="'rgc_' + gIndex + '_' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                    <input type="checkbox"
                                      :name="'rgField_' + index + '_' + gIndex + '_' + fieldIndex + '_' + oi"
                                      :value="opt"
                                      v-model="answers[index].respuesta[gIndex][campo.texto]"
                                      class="accent-teal-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </template>
                              <template v-else-if="campo.tipo === 'select'">
                                <div class="relative mt-1 mb-2">
                                  <select
                                    v-model="answers[index].respuesta[gIndex][campo.texto]"
                                    :name="'rgField_' + index + '_' + gIndex + '_' + fieldIndex"
                                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                  >
                                    <option disabled selected value="">Seleccione una</option>
                                    <option v-for="(option, oIndex) in campo.opciones" :key="'rgs_' + oIndex" :value="option">
                                      {{ option }}
                                    </option>
                                  </select>
                                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                    </svg>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </template>
                        </div>
                        
                        <button type="button" @click="addRepeatableGroup(index)" class="flex items-center text-sm text-teal-600 hover:text-teal-800 font-bold mb-3">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          Agregar otro registro
                        </button>

                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Complete los campos obligatorios.
                        </p>
                      </div>
                    </div>
                    <!-- /pregunta tipo GRUPO_REPETIBLE -->

                    <!-- pregunta tipo OPCION_SEGUIMIENTO -->
                    <div v-if="question.tipo === 'OPCION_SEGUIMIENTO'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <!-- Lista de Conceptos -->
                        <div v-for="(concepto, cIdx) in question.conceptos" :key="'concepto_' + cIdx" class="mb-4">
                          <label class="block text-gray-700 text-sm font-bold mb-2 text-left">{{ concepto }}</label>
                          <div class="flex gap-4 mb-2">
                            <label class="flex items-center gap-2 cursor-pointer font-bold text-sm text-gray-700">
                              <input type="radio"
                                :name="'followup_' + index + '_' + cIdx"
                                :value="question.opcion_si"
                                v-model="answers[index].respuesta[cIdx].selected_answer"
                                class="accent-green-500"
                              />
                              {{ question.opcion_si }}
                            </label>
                            <label class="flex items-center gap-2 cursor-pointer font-bold text-sm text-gray-700">
                              <input type="radio"
                                :name="'followup_' + index + '_' + cIdx"
                                :value="question.opcion_no"
                                v-model="answers[index].respuesta[cIdx].selected_answer"
                                class="accent-red-400"
                              />
                              {{ question.opcion_no }}
                            </label>
                          </div>
                          <!-- Sub-formulario (solo cuando selecciona opción SI) -->
                          <transition name="fade">
                            <div v-if="answers[index].respuesta[cIdx].selected_answer === question.opcion_si"
                              class="mt-2 p-3 bg-green-50 border border-green-200 rounded-lg"
                            >
                              <!-- Sub-tipo: radio -->
                              <div v-if="question.sub_tipo === 'radio'">
                                <div :class="question.sub_disposicion === 'horizontal' ? 'flex flex-wrap gap-4' : 'flex flex-col gap-2'">
                                  <label
                                    v-for="(opt, oi) in question.sub_opciones"
                                    :key="'sr_' + index + '_' + cIdx + '_' + oi"
                                    class="flex items-center gap-2 cursor-pointer text-sm text-gray-700"
                                  >
                                    <input type="radio"
                                      :name="'sub_radio_' + index + '_' + cIdx"
                                      :value="opt"
                                      v-model="answers[index].respuesta[cIdx].sub_respuesta"
                                      class="accent-green-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </div>
                              <!-- Sub-tipo: checkbox -->
                              <div v-if="question.sub_tipo === 'checkbox'">
                                <div :class="question.sub_disposicion === 'horizontal' ? 'flex flex-wrap gap-4' : 'flex flex-col gap-2'">
                                  <label
                                    v-for="(opt, oi) in question.sub_opciones"
                                    :key="'sc_' + index + '_' + cIdx + '_' + oi"
                                    class="flex items-center gap-2 cursor-pointer text-sm text-gray-700"
                                  >
                                    <input type="checkbox"
                                      :value="opt"
                                      v-model="answers[index].respuesta[cIdx].sub_respuesta"
                                      class="accent-green-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </div>
                              <!-- Sub-tipo: input -->
                              <div v-if="question.sub_tipo === 'input'">
                                <label v-if="question.sub_label" class="block text-xs font-bold text-gray-600 mb-1 uppercase tracking-wide">{{ question.sub_label }}</label>
                                <input
                                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white"
                                  :type="question.sub_input_tipo === 'numero' ? 'number' : (question.sub_input_tipo === 'fecha' ? 'date' : (question.sub_input_tipo === 'hora' ? 'time' : 'text'))"
                                  :min="question.sub_input_tipo === 'numero' && question.sub_rango_min !== null ? question.sub_rango_min : undefined"
                                  :max="question.sub_input_tipo === 'numero' && question.sub_rango_max !== null ? question.sub_rango_max : undefined"
                                  v-model="answers[index].respuesta[cIdx].sub_respuesta"
                                />
                              </div>
                            </div>
                          </transition>
                        </div>
                        <p v-if="answers[index].error" class="text-red-500 text-xs italic pb-3">Ingrese la respuesta.</p>
                      </div>
                    </div>
                    <!-- /pregunta tipo OPCION_SEGUIMIENTO -->

                    <!-- pregunta tipo MATRIZ -->
                    <div v-if="question.tipo === 'MATRIZ'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.- {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <div class="overflow-x-auto mb-3">
                          <table class="w-full text-left border-collapse">
                            <thead>
                              <tr>
                                <th class="border-b-2 p-2"></th>
                                <th
                                  v-for="(col, colIdx) in question.columnas"
                                  :key="'col' + colIdx"
                                  class="border-b-2 p-2 text-sm text-gray-700 font-bold text-center"
                                >
                                  {{ col }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(fila, filaIdx) in question.filas"
                                :key="'fila' + filaIdx"
                              >
                                <td class="border-b p-2 text-sm text-gray-700 font-bold">
                                  {{ fila }}
                                </td>
                                <td
                                  v-for="(col, colIdx) in question.columnas"
                                  :key="'cell' + colIdx"
                                  class="border-b p-2 text-center"
                                >
                                  <input
                                    type="radio"
                                    :name="'matrix_' + index + '_' + filaIdx"
                                    :value="col"
                                    v-model="answers[index].respuesta[fila]"
                                    class="leading-tight"
                                  />
                                </td>
                              </tr>
                              <tr v-if="question.otro">
                                  <td class="border-b p-2 text-sm text-gray-700 font-bold">
                                    <input
                                      v-if="!question.tipo_otro || question.tipo_otro === 'texto'"
                                      type="text"
                                      placeholder="Otro (opcional)..."
                                      class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                                      v-model="answers[index].respuesta_otro_fila"
                                    />
                                    <input
                                      v-else-if="question.tipo_otro === 'numero'"
                                      type="number"
                                      placeholder="Otro (opcional)..."
                                      class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                                      v-model.number="answers[index].respuesta_otro_fila"
                                    />
                                    <input
                                      v-else-if="question.tipo_otro === 'fecha'"
                                      type="date"
                                      placeholder="Otro (opcional)..."
                                      class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                                      v-model="answers[index].respuesta_otro_fila"
                                    />
                                    <input
                                      v-else-if="question.tipo_otro === 'hora'"
                                      type="time"
                                      placeholder="Otro (opcional)..."
                                      class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                                      v-model="answers[index].respuesta_otro_fila"
                                    />
                                  </td>
                                  <td
                                    v-for="(col, colIdx) in question.columnas"
                                    :key="'cell_otro_' + colIdx"
                                    class="border-b p-2 text-center"
                                  >
                                    <input
                                      type="radio"
                                      :name="'matrix_' + index + '_otro'"
                                      :value="col"
                                      v-model="answers[index].respuesta_otro_valor"
                                      class="leading-tight"
                                    />
                                  </td>
                                </tr>
                            </tbody>
                          </table>
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione una opción para todas las filas.
                        </p>
                      </div>
                    </div>
                    <!-- /pregunta tipo MATRIZ -->

                    <!-- pregunta tipo FECHA -->
                    <div v-if="question.tipo === 'FECHA'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <div class="w-1/2 lg:w-2/3 px-3 mb-6 md:mb-0">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            :id="'question' + index"
                            type="date"
                            :name="'question' + index"
                            v-model="answers[index].respuesta"
                          />
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
                      </div>
                    </div>
                    <!-- /pregunta tipo FECHA -->
                  </div>
                </div>
              </div>
              <!-- /Formulario de ficha -->

              <div v-show="showLastView">
                <div class="flex flex-wrap -mx-3 pb-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="name"
                      >Palabras clave</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="name"
                      type="text"
                      name="name"
                      v-model="nameLevantamiento"
                    />
                    <p
                      v-if="errors.name"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Ingrese al menos una palabra.
                    </p>
                  </div>

                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="helpUser"
                      >¿Alguien te proporcionó la información que
                      registraste?</label
                    >
                    <div class="relative">
                      <select
                        v-model="helpUser"
                        id="helpUser"
                        name="helpUser"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option disabled selected>Seleccione una</option>
                        <option :value="true">Si</option>
                        <option :value="false">No</option>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.helpUser"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Seleccione una opción.
                    </p>
                  </div>

                  <div class="flex flex-wrap -mx-3 pb-3" v-if="helpUser">
                    <div class="w-full px-3 mb-6 md:mb-0">
                      <label
                        class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                        >Registra los datos de tu informante</label
                      >
                    </div>
                    <div class="w-full px-3 mb-6 md:mb-0">
                      <label
                        class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                        for="username"
                        >Nombre</label
                      >
                      <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="username"
                        type="text"
                        name="username"
                        v-model="userData.Nombre"
                      />
                      <p
                        v-if="errors.user.name"
                        class="text-red-500 text-xs italic pb-3"
                      >
                        Ingrese el nombre del informante.
                      </p>
                    </div>

                    <div class="w-full px-3 mb-6 md:mb-0">
                      <label
                        class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                        for="userSex"
                        >Sexo</label
                      >
                      <div class="relative">
                        <select
                          v-model="userData.Sexo"
                          id="userSex"
                          name="userSex"
                          class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        >
                          <option disabled selected>Seleccione una</option>
                          <option value="Hombre">Hombre</option>
                          <option value="Mujer">Mujer</option>
                        </select>
                        <div
                          class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                        >
                          <svg
                            class="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path
                              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                            />
                          </svg>
                        </div>
                      </div>
                      <p
                        v-if="errors.user.sex"
                        class="text-red-500 text-xs italic pb-3"
                      >
                        Seleccione una opción.
                      </p>
                    </div>

                    <div class="w-full px-3 mb-6 md:mb-0">
                      <label
                        class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                        for="userAge"
                        >Edad</label
                      >
                      <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="userAge"
                        type="text"
                        name="userAge"
                        v-model="userData.Edad"
                      />
                      <p
                        v-if="errors.user.age"
                        class="text-red-500 text-xs italic pb-3"
                      >
                        Ingrese la edad del informante.
                      </p>
                    </div>

                    <div class="w-full px-3 mb-6 md:mb-0">
                      <label
                        class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                        for="userMaya"
                        >¿Es mayahablante?</label
                      >
                      <div class="relative">
                        <select
                          v-model="userData['Es mayahablante']"
                          id="userMaya"
                          name="userMaya"
                          class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        >
                          <option disabled selected>Seleccione una</option>
                          <option value="Si">Si</option>
                          <option value="No">No</option>
                        </select>
                        <div
                          class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                        >
                          <svg
                            class="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path
                              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                            />
                          </svg>
                        </div>
                      </div>
                      <p
                        v-if="errors.user.maya"
                        class="text-red-500 text-xs italic pb-3"
                      >
                        Seleccione una opción.
                      </p>
                    </div>
                  </div>

                  <!--                   <div class="w-full px-3 mb-6 md:mb-0 pt-2 border-t-2">
                    <label class="w-full flex items-center text-gray-900">
                      <input
                        class="mr-2 leading-tight"
                        type="checkbox"
                        v-model="sensitiveLocation"
                      />
                      <span class="text-sm"
                        >¿Desea compartir la ubicación precisa de este
                        registro?</span
                      >
                    </label>
                  </div> -->

                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label class="w-full flex items-center text-gray-900">
                      <input
                        class="mr-2 leading-tight"
                        type="checkbox"
                        v-model="hiddenQuestions"
                      />
                      <span class="text-sm"
                        >¿Deseas que tu registro sea privado?</span
                      >
                    </label>
                  </div>
                </div>
              </div>

              <div
                class="flex w-full sticky bottom-0 justify-end py-5 bg-white"
              >
                <button
                  v-if="showFormView || showMultimediaView || showLastView"
                  class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="backView()"
                >
                  Anterior
                </button>
                <button
                  v-if="showCategoriesView"
                  class="ml-2 bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="showMultimediaForm()"
                >
                  Siguiente
                </button>
                <button
                  v-if="showMultimediaView"
                  class="ml-2 bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="showLevantamientoForm()"
                >
                  Siguiente
                </button>
                <button
                  v-if="showFormView"
                  class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="showLastForm()"
                >
                  Siguiente
                </button>
                <button
                  v-if="showLastView"
                  class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveLevantamiento(false)"
                >
                  Guardar
                </button>
                <button
                  v-if="showLastView"
                  class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveLevantamiento(true)"
                >
                  Enviar a revisión
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¡Carga exitosa!</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      
      <div class="w-full">
        <span class="text-sm tracking-wide text-purple-500"
          >Su registro será evaluado y una vez aceptado podrá verlo en la página
          <a href="https://sv.geoint.mx/"
            >https://sv.geoint.mx/</a
          ></span
        >
      </div>
      <div class="w-full" v-if="answers.length === 0">
        <span class="text-sm tracking-wide text-purple-500"
          >Es necesario llenar la ficha del levantamiento</span
        >
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="close()"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error.</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-500"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessInfo">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¡Carga exitosa!</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <span class="text-sm tracking-wide text-purple-500"
          >Su registro será guardado y podrá verlo en la página
          <a href="https://sv.geoint.mx/"
            >https://sv.geoint.mx/</a
          ></span
        >
      </div>
      <div class="w-full" v-if="answers.length === 0">
        <span class="text-sm tracking-wide text-purple-500"
          >Es necesario llenar la ficha del levantamiento</span
        >
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="close()"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingMediaError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ mediaErrorMsg }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-500"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingMediaError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <levantamiento-project-modal
      :showing="showingProjectModal"
      :projectId="projectSelected"
      @close="showingProjectModal = false"
    ></levantamiento-project-modal>

    <project-media-levantamiento
      :showing="showingMediaProject"
      :especificacion="especificacion"
      @close="showingMediaProject = false"
    ></project-media-levantamiento>
  </div>
</template>
<script>
import config from "../../vue.config.js";
import AlertDialog from "./AlertDialog";
import moment from "moment";
import LevantamientoProjectModal from "./LevantamientoProjectModal";
import EventBus from "../event-bus";
import ProjectMediaLevantamiento from "./ProjectMediaLevantamiento";

export default {
  data() {
    return {
      fileMimeType: null,
      categorySelected: null,
      categories: [],
      subcategorySelected: null,
      subcategories: [],
      nameLevantamiento: null,
      showCategoriesView: true,
      showMultimediaView: false,
      showFormView: false,
      questions: [],
      answers: [],
      surveyStartTime: null,
      sectionTimes: {},
      currentSectionFocused: null,
      lastFocusTime: null,
      inputFilePlaceholder: "Sin archivos seleccionados",
      levantamientoMediaUrl: null,
      imageSelected: false,
      videoSelected: false,
      errors: {
        selectCategory: false,
        selectSubcategory: false,
        name: false,
        file_extension: false,
        codeError: "Ha ocurrido un error",
        selectProject: false,
        isMaterial: false,
        emptyFile: false,
        helpUser: false,
        user: {
          name: false,
          sex: false,
          age: false,
          maya: false
        }
      },
      showingSuccess: false,
      showingSuccessInfo: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      projects: [],
      projectSelected: null,
      fromProject: "Si",
      isMaterial: null,
      imagesPreviews: [
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" }
      ],
      showingMediaError: false,
      mediaErrorMsg: "",
      showingProjectModal: false,
      showingMediaProject: false,
      especificacion: null,
      sensitiveLocation: true,
      hiddenQuestions: false,
      showLastView: false,
      helpUser: null,
      userData: {
        Nombre: "",
        Sexo: "",
        Edad: "",
        "Es mayahablante": ""
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    latitud: {
      required: true,
      type: Number
    },
    longitud: {
      required: true,
      type: Number
    }
  },
  watch: {
    showing(value) {
      if (value) {
        this.surveyStartTime = Date.now();
        this.sectionTimes = {};
        this.currentSectionFocused = null;
        this.lastFocusTime = Date.now();
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  mounted() {
    this.fetchCategories();
    this.fetchProjects();
  },
  components: {
    AlertDialog,
    LevantamientoProjectModal,
    ProjectMediaLevantamiento
  },
  computed: {
    nestedStatusFicha() {
      let inSection = false;
      if (!this.questions) return [];
      return this.questions.map(q => {
        if (q.tipo === 'SECCION') {
          inSection = true;
          return false;
        }
        return inSection;
      });
    }
  },
  methods: {
    handleFocusIn(event) {
      let qDiv = event.target.closest('[data-q-index]');
      if (!qDiv) return;
      let qIndex = parseInt(qDiv.getAttribute('data-q-index'));
      
      let sectionName = "General";
      for (let i = qIndex; i >= 0; i--) {
        if (this.questions[i] && this.questions[i].tipo === 'SECCION') {
          sectionName = this.questions[i].texto;
          break;
        }
      }
      
      const now = Date.now();
      if (this.currentSectionFocused && this.currentSectionFocused !== sectionName) {
        let diff = now - this.lastFocusTime;
        if (!this.sectionTimes[this.currentSectionFocused]) {
          this.sectionTimes[this.currentSectionFocused] = 0;
        }
        this.sectionTimes[this.currentSectionFocused] += diff;
      }
      this.currentSectionFocused = sectionName;
      this.lastFocusTime = now;
    },
    isQuestionVisible(index) {
      if (index === 0) return true;
      let targetJumpIndex = -1;

      for (let i = 0; i < index; i++) {
        let q = this.questions[i];
        let a = this.answers[i];
        if (q.tipo === "SELECCION" && q.saltos && a && a.respuesta) {
          let selectedVal = a.respuesta.selected_answer;
          let saltoTarget = null;
          
          if (selectedVal !== "") {
            if (selectedVal === "Otro") {
              saltoTarget = q.saltos['otro'];
            } else {
              let optIndex = q.opciones.indexOf(selectedVal);
              if (optIndex !== -1) {
                saltoTarget = q.saltos[optIndex];
              }
            }

            if (saltoTarget) {
              let tIndex = this.questions.findIndex(x => x.numero_pregunta == saltoTarget);
              if (tIndex > i && tIndex > targetJumpIndex) {
                targetJumpIndex = tIndex;
              }
            }
          }
        }
      }

      return index >= targetJumpIndex;
    },
    addRepeatableGroup(index) {
      let emptyGroup = {};
      if (this.questions[index].campos) {
        this.questions[index].campos.forEach(field => {
          if (field.tipo === 'checkbox') {
            emptyGroup[field.texto] = [];
          } else {
            emptyGroup[field.texto] = "";
          }
        });
      }
      this.answers[index].respuesta.push(emptyGroup);
    },
    onPhotoChange(event, index) {
      const files = event.target.files;
      if (!files || files.length === 0) return;
      const maxFotos = (this.questions[index] && this.questions[index].max_fotos) ? this.questions[index].max_fotos : 4;

      let currentPhotos = Array.isArray(this.answers[index].respuesta)
        ? [...this.answers[index].respuesta]
        : (this.answers[index].respuesta ? [this.answers[index].respuesta] : []);

      const availableSlots = maxFotos - currentPhotos.length;
      if (availableSlots <= 0) {
        event.target.value = "";
        return;
      }

      const filesToAdd = Array.from(files).slice(0, availableSlots);

      filesToAdd.forEach(file => {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (!Array.isArray(this.answers[index].respuesta)) {
            this.$set(this.answers[index], 'respuesta', []);
          }
          this.answers[index].respuesta.push(e.target.result);
          this.answers[index].error = false;
        };
        reader.readAsDataURL(file);
      });
      event.target.value = "";
    },
    removePhoto(questionIndex, photoIndex) {
      if (Array.isArray(this.answers[questionIndex].respuesta)) {
        this.answers[questionIndex].respuesta.splice(photoIndex, 1);
      } else {
        this.$set(this.answers[questionIndex], 'respuesta', []);
      }
    },
    reset: function () {
      this.fileMimeType = null;
      this.categorySelected = null;
      this.subcategorySelected = null;
      this.subcategories = [];
      this.nameLevantamiento = null;
      this.showCategoriesView = true;
      this.showMultimediaView = false;
      this.showFormView = false;
      this.showLastView = false;
      this.questions = [];
      this.answers = [];
      this.imageSelected = false;
      this.videoSelected = false;
      this.inputFilePlaceholder = "Sin archivos seleccionados";
      this.errors = {
        selectCategory: false,
        selectSubcategory: false,
        name: false,
        file_extension: false,
        codeError: "Ha ocurrido un error",
        selectProject: false,
        isMaterial: false,
        emptyFile: false,
        user: {
          name: false,
          sex: false,
          age: false,
          maya: false
        }
      };
      this.showingSuccess = false;
      this.showingSuccessInfo = false;
      this.showingError = false;
      this.projectSelected = null;
      this.fromProject = "Si";
      this.isMaterial = null;
      this.imagesPreviews = [
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" }
      ];
      this.showingMediaError = false;
      this.mediaErrorMsg = "";
      this.showingProjectModal = false;
      this.showingMediaProject = false;
      this.especificacion = null;
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    fetchCategories() {
      this.axios
        .get("apidev/categories/catprinc/getMainCategories", this.config)
        .then(response => {
          this.categories = response.data.categorias;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchSubcategories() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/categories/subcategorias/getSubcategories",
          {
            id_maincategory: this.categorySelected
          },
          this.config
        )
        .then(response => {
          this.subcategories = response.data.subcategorias;
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          // removed console log
          if (error["response"]) {
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
          }

          this.$root.$emit("hideLoading");
        });
    },
    fetchQuestions() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getFichaPreguntas",
          {
            id_cat_principal: this.isMaterial,
            existente: true
          },
          this.config
        )
        .then(response => {
          this.questions = response.data.questions;

          this.formatQuestions();

          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          // removed console log
          if (error["response"]) {
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
          }

          this.$root.$emit("hideLoading");
        });
    },
    fetchProjectQuestions() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/projects/getFichaRespuestasJson",
          {
            id_project: this.projectSelected
          },
          this.config
        )
        .then(response => {
          this.questions = response.data.answers;

          this.formatQuestions();

          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          // removed console log
          if (error["response"]) {
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    formatQuestions() {
      this.answers = [];
      this.questions.forEach(question => {
        let answer;

        switch (question.tipo) {
          case "ABIERTA":
            answer = "";
            break;
          case "FOTO":
            answer = "";
            break;
          case "MULTISELECCION":
            answer = {
              opciones: {}
            };

            question.opciones.forEach(option => {
              answer.opciones[option] = false;
            });

            if (question.otro) {
              answer["otro"] = "";
            }

            /*             if (question["subpregunta"] && question["subpregunta"].length>0) {
              answer["subpregunta"] = {};
              answer["subpregunta"]["id_pregunta"] =
                question["subpregunta"][0].id_pregunta;
              answer["subpregunta"]["texto"] = question["subpregunta"][0].texto;
              answer["subpregunta"]["tipo"] = question["subpregunta"][0].tipo;
              answer["subpregunta"]["respuesta"] = {};
              if (question["subpregunta"][0].tipo == "CAMPOS") {
                answer["subpregunta"]["sensible"] = false;
                question["subpregunta"][0].campos.forEach((field) => {
                  answer["subpregunta"]["respuesta"][field.texto] = "";
                });
              }
            } */
            if (question["subpregunta"] && question["subpregunta"].length > 0) {
              if (question["subpregunta"].length > 0) {
                answer["subpregunta"] = [];
                question["subpregunta"].forEach(question => {
                  let subAnswer = {
                    respuesta: null
                  };
                  subAnswer.id_pregunta = question.id_pregunta;
                  subAnswer.texto = question.texto;
                  subAnswer.tipo = question.tipo;
                  if (question.tipo === "ABIERTA") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = "";
                  }

                  if (question.tipo === "SELECCION") {
                    subAnswer.respuesta = {
                      selected_answer: "",
                      otro: ""
                    };
                  }

                  if (question.tipo === "CAMPOS") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = {};

                    question.campos.forEach(campo => {
                      subAnswer.respuesta[campo.texto] = "";
                    });
                  }

                  subAnswer.error = false;

                  answer["subpregunta"].push(subAnswer);
                });
              }
            }

            break;
          case "MULTISELECCION_CATEGORIAS":
            answer = {};
            if (question["otro"] == true) {
              answer["otro"] = "";
            }
            answer["categorias"] = {};
            question.categorias.forEach(categoria => {
              answer["categorias"][categoria.categoria_nombre] = {};
              categoria.opciones.forEach(opcion => {
                answer["categorias"][categoria.categoria_nombre][
                  opcion
                ] = false;
              });
            });
            break;
          case "SELECCION_CONDICIONAL":
            answer = {};
            answer["selected_answer"] = "";
            answer["conditional_answer"] = {};

            Object.entries(question.pregunta_condicion).forEach(
              ([key, value]) => {
                answer["conditional_answer"][key] = {};
                answer["conditional_answer"][key]["id"] = value["id"];
                answer["conditional_answer"][key]["tipo"] = value["tipo"];
                answer["conditional_answer"][key]["texto"] = value["texto"];

                if (value["tipo"] == "ABIERTA") {
                  answer["conditional_answer"][key]["sensible"] = false;
                  answer["conditional_answer"][key]["respuesta"] = "";
                }
                if (value["tipo"] == "MULTISELECCION") {
                  answer["conditional_answer"][key]["respuesta"] = {};

                  answer["conditional_answer"][key]["respuesta"]["opciones"] =
                    {};
                  value["opciones"].forEach(opcion => {
                    answer["conditional_answer"][key]["respuesta"]["opciones"][
                      opcion
                    ] = false;
                  });

                  if (value["otro"] == true) {
                    answer["conditional_answer"][key]["respuesta"]["otro"] = "";
                  }
                }
                if (value["tipo"] == "MULTISELECCION_CATEGORIAS") {
                  answer["conditional_answer"][key]["respuesta"] = {};
                  answer["conditional_answer"][key]["respuesta"]["categorias"] =
                    {};
                  value["categorias"].forEach(categoria => {
                    answer["conditional_answer"][key]["respuesta"][
                      "categorias"
                    ][categoria.categoria_nombre] = {};
                    categoria.opciones.forEach(opcion => {
                      answer["conditional_answer"][key]["respuesta"][
                        "categorias"
                      ][categoria.categoria_nombre][opcion] = false;
                    });
                  });
                  if (value["otro"] == true) {
                    answer["conditional_answer"][key]["respuesta"]["otro"] = "";
                  }
                }

                if (value["tipo"] == "SELECCION") {
                  answer["conditional_answer"][key]["respuesta"] = "";
                }

                if (value["tipo"] === "CAMPOS") {
                  answer["conditional_answer"][key]["sensible"] = false;
                  answer["conditional_answer"][key]["respuesta"] = {};
                  question.pregunta_condicion[key].campos.forEach(field => {
                    answer["conditional_answer"][key]["respuesta"][
                      field.texto
                    ] = "";
                  });
                }

                if (question.pregunta_condicion[key].subpregunta) {
                  let subAnswers = [];
                  question.pregunta_condicion[key].subpregunta.forEach(
                    subpregunta => {
                      let subAnswer = {
                        id_pregunta: subpregunta.id_pregunta,
                        numero_pregunta: subpregunta.numero_pregunta,
                        texto: subpregunta.texto,
                        tipo: subpregunta.tipo,
                        respuesta: ""
                      };

                      if (subAnswer.tipo === "ABIERTA") {
                        subAnswer.sensible = false;
                      }

                      subAnswers.push(subAnswer);
                    }
                  );

                  answer["conditional_answer"][key].subpregunta = subAnswers;
                }

                answer["conditional_answer"][key]["error"] = false;
              }
            );
            break;
          case "SELECCION":
            answer = {};
            answer["selected_answer"] = "";
            if (question.otro) {
              answer["otro"] = "";
            }
            if (question["subpregunta"] && question["subpregunta"].length > 0) {
              if (question["subpregunta"].length > 0) {
                answer["subpregunta"] = [];
                question["subpregunta"].forEach(question => {
                  let subAnswer = {
                    respuesta: null
                  };
                  subAnswer.id_pregunta = question.id_pregunta;
                  subAnswer.texto = question.texto;
                  subAnswer.tipo = question.tipo;
                  if (question.tipo === "ABIERTA") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = "";
                  }

                  if (question.tipo === "SELECCION") {
                    subAnswer.respuesta = {
                      selected_answer: ""
                    };
                  }

                  if (question.tipo === "CAMPOS") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = {};

                    question.campos.forEach(campo => {
                      subAnswer.respuesta[campo.texto] = "";
                    });
                  }

                  subAnswer.error = false;

                  answer["subpregunta"].push(subAnswer);
                });
              }
            }
            break;
          case "CAMPOS":
            answer = {};
            if (question.campos) {
              question.campos.forEach(field => {
                answer[field.texto] = "";
              });
            }
            break;
          case "MINI_FORMULARIO":
            answer = {};
            if (question.campos) {
              question.campos.forEach(field => {
                if (field.tipo === 'checkbox') {
                  answer[field.texto] = [];
                } else {
                  answer[field.texto] = "";
                }
              });
            }
            break;
          case "GRUPO_REPETIBLE":
            answer = [];
            let emptyGroup = {};
            if (question.campos) {
              question.campos.forEach(field => {
                if (field.tipo === 'checkbox') {
                  emptyGroup[field.texto] = [];
                } else {
                  emptyGroup[field.texto] = "";
                }
              });
            }
            answer.push(emptyGroup);
            break;
          case "OPCION_SEGUIMIENTO":
            answer = [];
            if (question.conceptos) {
              question.conceptos.forEach(concepto => {
                answer.push({
                  concepto: concepto,
                  selected_answer: "",
                  sub_respuesta: question.sub_tipo === 'checkbox' ? [] : ""
                });
              });
            }
            break;
          case "MATRIZ":
            answer = {};
            if (question.filas) {
              question.filas.forEach(fila => {
                answer[fila] = "";
              });
            }
            break;
          case "FECHA":
            answer = "";
            break;
          default:
            break;
        }

        let answerQuestion = {
          id_pregunta: question.id_pregunta,
          numero_pregunta: question.numero_pregunta,
          texto: question.texto,
          tipo: question.tipo,
          respuesta: answer,
          respuesta_otro_fila: "",
          respuesta_otro_valor: "",
          obligatoria: question.obligatoria,
          error: false
        };

        if (
          answerQuestion.tipo === "ABIERTA" ||
          answerQuestion.tipo === "CAMPOS" ||
          answerQuestion.tipo === "MINI_FORMULARIO" ||
          answerQuestion.tipo === "GRUPO_REPETIBLE"
        ) {
          answerQuestion.sensible = false;
        }

        this.answers.push(answerQuestion);
      });
    },
    fetchProjects() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/projects/getAllProjectsList",
          {
            activos: true
          },
          this.config
        )
        .then(response => {
          this.projects = response.data.proyectos;
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    showMultimediaForm() {
      const form = document.getElementById("levantamientoForm");
      const formData = new FormData(form);
      const validForm = this.validateForm(formData);

      if (validForm) {
        let project = this.projects.find(
          project => project.id === this.projectSelected
        );

        if (project != null && project != undefined) {
          this.especificacion = project.especificaciones_multimedia;
        } else {
          this.especificacion =
            "Puede subir hasta cuatro fotografías (jpg) o un video (mp4)";
        }

        this.showCategoriesView = false;
        this.showFormView = false;
        this.showMultimediaView = true;
      }
    },
    showLevantamientoForm() {
      const validForm = this.validateMultimedia();

      if (validForm) {
        this.showCategoriesView = false;
        this.showMultimediaView = false;
        this.showFormView = true;

        if (this.fromProject === "No") {
          this.fetchQuestions();
        } else {
          this.fetchProjectQuestions();
        }
      }
    },
    showLastForm() {
      const validQuestions = this.validateAnswers();

      if (validQuestions) {
        this.showCategoriesView = false;
        this.showMultimediaView = false;
        this.showFormView = false;
        this.showLastView = true;
      }
    },
    saveLevantamiento(revision) {
      const form = document.getElementById("levantamientoForm");
      const formData = new FormData(form);
      const validLastForm = this.validateLastForm(formData);

      if (validLastForm) {
        //// removed console log
        this.$root.$emit("showLoading");
        let request = {};
        let date = new Date();
        //hace la correccion de time offset de la fecha
        let fecha = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        let fecha_registro = new Date().toLocaleString("es-MX", {
          timeZone: "America/Mexico_City"
        });

        let userAnswers = {};

        this.answers.forEach(answer => {
          delete answer.error;
          if (answer.tipo === "SELECCION_CONDICIONAL") {
            let user_answer = {};
            for (let key in answer.respuesta.conditional_answer) {
              if (key === answer.respuesta.selected_answer) {
                delete answer.respuesta.conditional_answer[key].error;
                user_answer[key] = answer.respuesta.conditional_answer[key];
              }
            }

            answer.respuesta.conditional_answer = user_answer;
          }

          if (answer.tipo === "SELECCION") {
            if (answer.respuesta.selected_answer !== "Otro") {
              answer.respuesta.otro = "";
            }
            if (answer.respuesta.subpregunta) {
              if (answer.respuesta.subpregunta.length > 0) {
                answer.respuesta.subpregunta.forEach(subpregunta => {
                  delete subpregunta.error;
                });
              }
            }
          }

          if (answer.tipo === "MATRIZ") {
            if (answer.respuesta_otro_fila && answer.respuesta_otro_fila.trim() !== "" && answer.respuesta_otro_valor) {
              answer.respuesta.otro_texto = answer.respuesta_otro_fila.trim();
              answer.respuesta.otro_respuesta = answer.respuesta_otro_valor;
            } else {
              delete answer.respuesta.otro_texto;
              delete answer.respuesta.otro_respuesta;
            }
          }
        });

        this.questions.forEach((question, index) => {
          userAnswers[question.id_pregunta] = this.answers[index];
        });

        if (this.currentSectionFocused) {
          let diff = Date.now() - this.lastFocusTime;
          if (!this.sectionTimes[this.currentSectionFocused]) {
            this.sectionTimes[this.currentSectionFocused] = 0;
          }
          this.sectionTimes[this.currentSectionFocused] += diff;
        }

        userAnswers['tiempos_encuesta'] = {
          total: Date.now() - this.surveyStartTime,
          secciones: this.sectionTimes
        };

        if (this.fromProject === "No") {
          this.projectSelected = null;
        } else {
          this.isMaterial = 3; //es ficha de proyecto
        }

        let dataToSendOptions = [];

        this.imagesPreviews.forEach((preview, index) => {
          if (preview.type !== "") {
            const newDate = new Date();
            const mediaFilename =
              localStorage.getItem("user_id") +
              "_" +
              newDate.getTime() +
              "_" +
              index +
              preview.extension;

            let options = {
              fileKey: "levantamientoFile",
              fileName: mediaFilename,
              mimeType: preview.mimeType
            };

            dataToSendOptions.push(options);
          }
        });

        request = {
          id_cat_principal: this.isMaterial,
          id_cat_secundaria: 0,
          //id_cat_secundaria: this.subcategorySelected,
          id_usuario: localStorage.getItem("user_id"),
          titulo: this.nameLevantamiento,
          registro: null,
          respuestas: userAnswers,
          multimedia: null,
          //fecha_levantamiento: new Date(),
          fecha_levantamiento: fecha_registro,
          geometry: {},
          fuente: "web",
          latitud: this.latitud,
          longitud: this.longitud,
          id_proyecto: this.projectSelected,
          DatatoSendOptions: dataToSendOptions,
          ubicacion_sensible: !this.sensitiveLocation,
          ocultar_ficha: this.hiddenQuestions,
          datos_usuario: this.helpUser ? this.userData : {},
          revision: revision
        };

        this.axios
          .post("apidev/levantamientos/newLevantamiento", request, this.config)
          .then(response => {
            if (document.getElementById("levantamientoFile").value !== "") {
              let levantamientoId = response.data.levantamiento_id;
              let promises = [];

              dataToSendOptions.forEach((option, index) => {
                let formData = new FormData();
                formData.append("id", levantamientoId);
                const file =
                  document.getElementById("levantamientoFile").files[index];

                formData.append("levantamientoFile", file, option.fileName);

                let promise = this.axios.post(
                  "apidev/levantamientos/media",
                  formData,
                  this.config
                );

                promises.push(promise);
              });

              Promise.all(promises)
                .then(response => {
                  if (revision) {
                    this.showingSuccess = true;
                  } else {
                    this.showingSuccessInfo = true;
                  }
                  this.$root.$emit("hideLoading");
                })
                .catch(error => {
                  if (
                    error.response.status == 400 ||
                    error.response.status == 401
                  ) {
                    if (
                      error.response.data.name === "TokenExpiredError" ||
                      error.response.data.name === "InvalidTokenError" ||
                      error.response.data.name === "JsonWebTokenError"
                    ) {
                      this.$router.push({ path: "/login" });
                    }
                  }
                  this.$root.$emit("hideLoading");
                });
            } else {
              if (revision) {
                this.showingSuccess = true;
              } else {
                this.showingSuccessInfo = true;
              }
              this.$root.$emit("hideLoading");
            }
          })
          .catch(error => {
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
            this.$root.$emit("hideLoading");
          });
      }
    },
    backView() {
      if (this.showFormView) {
        this.showFormView = false;
        this.showMultimediaView = true;
      } else {
        if (this.showMultimediaView) {
          this.showMultimediaView = false;
          this.showCategoriesView = true;
        } else {
          if (this.showLastView) {
            this.showLastView = false;
            this.showFormView = true;
          }
        }
      }
    },
    validateForm(data) {
      /* if (data.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      } */

      if (data.get("selectProject") === null) {
        this.errors.selectProject = true;
      } else {
        this.errors.selectProject = false;
      }

      /* if (data.get("fromProject") === "No") {
        //if (this.isMaterial === null || this.isMaterial === undefined || this.isMaterial === "") {
        if (data.get("isMaterial") === null) {
          this.errors.isMaterial = true;
        } else {
          this.errors.isMaterial = false;
        }
      } */

      if (
        /* this.errors.name || */
        this.errors.selectProject ||
        this.errors.isMaterial
      ) {
        return false;
      }

      return true;
    },
    validateMultimedia() {
      if (document.getElementById("levantamientoFile").value === "") {
        this.errors.emptyFile = true;
      } else {
        this.errors.emptyFile = false;
      }

      return !this.errors.emptyFile;
    },
    changeLevantamientoFile(event) {
      const files = event.target.files;

      const filesArray = Array.from(files);

      let videoArray = filesArray.filter(file => file.type.includes("video"));

      if (videoArray.length <= 1) {
        if (
          videoArray.length === 0 ||
          (videoArray.length === 1 && filesArray.length === 1)
        ) {
          if (filesArray.length <= 4) {
            this.imageSelected = true;

            this.imagesPreviews = [
              { type: "", mediaUrl: null, mimeType: "" },
              { type: "", mediaUrl: null, mimeType: "" },
              { type: "", mediaUrl: null, mimeType: "" },
              { type: "", mediaUrl: null, mimeType: "" }
            ];
            this.inputFilePlaceholder = "";
            filesArray.forEach((file, index) => {
              const fileMimeType = this.checkMimeType(file);

              if (fileMimeType === "") {
                this.errors.file_extension = true;
              } else {
                if (fileMimeType === ".mp4") {
                  this.inputFilePlaceholder += `${file.name},`;
                  this.errors.file_extension = false;

                  this.imagesPreviews[index].type = "video";
                  this.imagesPreviews[index].mediaUrl =
                    URL.createObjectURL(file);
                  this.imagesPreviews[index].mimeType = file.type;
                  this.imagesPreviews[index].extension = fileMimeType;
                } else {
                  this.inputFilePlaceholder += `${file.name},`;

                  let image = new Image();
                  image.src = URL.createObjectURL(file);
                  image.onload = () => {
                    this.errors.file_extension = false;

                    this.imagesPreviews[index].type = "image";
                    this.imagesPreviews[index].mediaUrl =
                      URL.createObjectURL(file);
                    this.imagesPreviews[index].mimeType = file.type;
                    this.imagesPreviews[index].extension = fileMimeType;
                  };
                }
              }
            });
          } else {
            document.getElementById("levantamientoFile").value = "";
            this.mediaErrorMsg = "Seleccione un máximo de 4 fotos.";
            this.showingMediaError = true;
          }
        } else {
          document.getElementById("levantamientoFile").value = "";
          this.mediaErrorMsg = "Seleccione hasta 4 fotos o un video.";
          this.showingMediaError = true;
        }
      } else {
        document.getElementById("levantamientoFile").value = "";
        this.mediaErrorMsg = "Seleccione un máximo de un video.";
        this.showingMediaError = true;
      }
    },
    checkMimeType(file) {
      let mimeType = "";
      switch (file.type) {
        case "image/jpeg":
          mimeType = ".jpeg";
          break;
        case "image/png":
          mimeType = ".png";
          break;
        case "image/jpg":
          mimeType = ".jpg";
          break;
        case "video/mp4":
          mimeType = ".mp4";
          break;
        default:
          mimeType = "";
          break;
      }
      return mimeType;
    },
    validateAnswers() {
      let requiredAnswers = this.answers.filter((answer, index) => answer.obligatoria && this.isQuestionVisible(index));

      let isValid = true;

      requiredAnswers.forEach(answer => {
        switch (answer.tipo) {
          case "ABIERTA":
            let q = this.questions[this.answers.indexOf(answer)];
            if (answer.respuesta === "") {
              isValid = false;
              answer.error = true;
              answer.error_rango = false;
            } else {
              answer.error = false;
              if (q.tipo_dato === "numero") {
                let val = parseFloat(answer.respuesta);
                if (
                  (q.rango_min !== null && val < q.rango_min) ||
                  (q.rango_max !== null && val > q.rango_max)
                ) {
                  isValid = false;
                  answer.error_rango = true;
                } else {
                  answer.error_rango = false;
                }
              } else {
                answer.error_rango = false;
              }
            }
            break;
          case "FOTO":
            if (
              !answer.respuesta ||
              (Array.isArray(answer.respuesta) && answer.respuesta.length === 0) ||
              answer.respuesta === ""
            ) {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
            }
            break;
          case "SELECCION":
            if (answer.respuesta.selected_answer === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
            }

            if (answer.respuesta.subpregunta) {
              answer.respuesta.subpregunta.forEach(subpregunta => {
                if (subpregunta.tipo === "ABIERTA") {
                  if (subpregunta.respuesta === "") {
                    isValid = false;
                    subpregunta.error = true;
                  } else {
                    subpregunta.error = false;
                  }
                }

                if (subpregunta.tipo === "SELECCION") {
                  if (subpregunta.respuesta.selected_answer === "") {
                    isValid = false;
                    subpregunta.error = true;
                  } else {
                    subpregunta.error = false;
                  }
                }

                if (subpregunta.tipo === "CAMPOS") {
                  let haveEmpty = false;
                  for (let key in subpregunta.respuesta) {
                    if (subpregunta.respuesta[key] === "") {
                      haveEmpty = true;
                      isValid = false;
                      subpregunta.error = true;
                    }
                  }

                  if (!haveEmpty) {
                    subpregunta.error = false;
                  }
                }
              });
            }

            break;
          case "SELECCION_CONDICIONAL":
            if (answer.respuesta.selected_answer === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
              if (
                answer.respuesta.conditional_answer[
                  answer.respuesta.selected_answer
                ]
              ) {
                if (
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].respuesta === ""
                ) {
                  isValid = false;
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].error = true;
                } else {
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].error = false;
                }
              }
            }
            break;
          case "OPCION_SEGUIMIENTO":
            if (answer.obligatoria) {
              let incomplete = false;
              if (Array.isArray(answer.respuesta)) {
                for (let i = 0; i < answer.respuesta.length; i++) {
                  let r = answer.respuesta[i];
                  if (!r.selected_answer) {
                    incomplete = true;
                    break;
                  }
                  if (r.selected_answer === answer.opcion_si) {
                    if (answer.sub_tipo === 'checkbox') {
                      if (!r.sub_respuesta || r.sub_respuesta.length === 0) {
                        incomplete = true;
                        break;
                      }
                    } else {
                      if (!r.sub_respuesta || r.sub_respuesta.toString().trim() === "") {
                        incomplete = true;
                        break;
                      }
                    }
                  }
                }
              } else {
                incomplete = true;
              }
              if (incomplete) {
                isValid = false;
                answer.error = true;
              } else {
                answer.error = false;
              }
            } else {
              answer.error = false;
            }
            break;
          case "MINI_FORMULARIO":
          case "CAMPOS": {
            let haveEmpty = false;
            for (let key in answer.respuesta) {
              if (answer.respuesta[key] === "" || (Array.isArray(answer.respuesta[key]) && answer.respuesta[key].length === 0)) {
                haveEmpty = true;
                isValid = false;
                answer.error = true;
              }
            }

            if (!haveEmpty) {
              answer.error = false;
            }
            break;
          }
          case "GRUPO_REPETIBLE": {
            let haveEmpty = false;
            if (Array.isArray(answer.respuesta)) {
              for (let i = 0; i < answer.respuesta.length; i++) {
                let group = answer.respuesta[i];
                for (let key in group) {
                  if (group[key] === "" || (Array.isArray(group[key]) && group[key].length === 0)) {
                    haveEmpty = true;
                    isValid = false;
                    answer.error = true;
                  }
                }
              }
            }
            if (!haveEmpty) {
              answer.error = false;
            }
            break;
          }
          case "MATRIZ": {
            let haveEmpty = false;
            let q = this.questions[this.answers.indexOf(answer)];
            if (q && q.filas) {
              for (let fila of q.filas) {
                if (!answer.respuesta || answer.respuesta[fila] === "" || answer.respuesta[fila] === null || answer.respuesta[fila] === undefined) {
                  haveEmpty = true;
                  isValid = false;
                  answer.error = true;
                  break;
                }
              }
            }
            if (!haveEmpty) {
              answer.error = false;
            }
            break;
          }
          case "FECHA":
            if (answer.respuesta === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
            }
            break;
          default:
            break;
        }
      });

      return isValid;
    },
    showProjectDetailModal() {
      this.showingProjectModal = true;
      EventBus.$emit("showProjectDetailNew", {
        id_proyecto: this.projectSelected
      });
    },

    selectOptionLevantamiento(option) {
      //// removed console log
      var optionMaterial = document.getElementById("optionMaterial");
      var optionInmaterial = document.getElementById("optionInmaterial");

      this.isMaterial = option;

      if (option == "1") {
        //material
        optionMaterial.classList.add("optionSelected");
        optionInmaterial.classList.remove("optionSelected");
      }
      if (option == "2") {
        //inmaterial
        optionInmaterial.classList.add("optionSelected");
        optionMaterial.classList.remove("optionSelected");
      }
    },
    validateLastForm(data) {
      if (data.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (data.get("helpUser") === null) {
        this.errors.helpUser = true;
      } else {
        this.errors.helpUser = false;
      }

      if (this.helpUser) {
        if (data.get("username") === "") {
          this.errors.user.name = true;
        } else {
          this.errors.user.name = false;
        }

        if (data.get("userSex") === null) {
          this.errors.user.sex = true;
        } else {
          this.errors.user.sex = false;
        }

        if (data.get("userAge") === "") {
          this.errors.user.age = true;
        } else {
          this.errors.user.age = false;
        }

        if (data.get("userMaya") === null) {
          this.errors.user.maya = true;
        } else {
          this.errors.user.maya = false;
        }
      }

      if (
        this.errors.name ||
        this.errors.helpUser ||
        this.errors.user.name ||
        this.errors.user.sex ||
        this.errors.user.age ||
        this.errors.user.maya
      ) {
        return false;
      }

      return true;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}

.optionTypeLevantamiento {
  height: 100%;
  display: flex;
  align-items: center;
  border-radius: 15px;
  padding: 10px;
}

.optionTypeLevantamiento:hover {
  cursor: pointer;
  border: solid;
  border-color: blue;
  border-width: 1;
}

.optionSelected {
  border: solid;
  border-color: rgb(0, 0, 0);
  border-width: 7;
}
</style>
